// extracted by mini-css-extract-plugin
module.exports = {"newsletter":"S_dD"};